export const GA_ID = 'G-F6BF2QKX8J';
export const CONSENT_KEY = 'ga_consent';

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // storage unavailable; choice applies to this page view only
  }
  const granted = value === 'granted';
  window[`ga-disable-${GA_ID}`] = !granted;
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', { analytics_storage: granted ? 'granted' : 'denied' });
  }
};

export const trackEvent = (name, params = {}) => {
  if (getConsent() === 'denied' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
};
